// Importa as funções necessárias do Firebase
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth"; // Usa OAuthProvider para Microsoft
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // Importação do Storage

// Configuração do Firebase
const firebaseConfig = {
  apiKey: "AIzaSyCdB4mOl9WAbm65NJqyPTyuxwwGjSuY61A",
  authDomain: "finnoplan-controle-pessoal.firebaseapp.com",
  projectId: "finnoplan-controle-pessoal",
  storageBucket: "finnoplan-controle-pessoal.appspot.com",
  messagingSenderId: "1034081489052",
  appId: "1:1034081489052:web:7ef1f23ccf2f4867e69d59",
  measurementId: "G-KDB25TGMH3",
};

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa e exporta autenticação
export const auth = getAuth(app);

// Inicializa e exporta Firestore
export const firestore = getFirestore(app);

// Inicializa e exporta provedores de autenticação
export const googleProvider = new GoogleAuthProvider(); // Provedor do Google
export const microsoftProvider = new OAuthProvider("microsoft.com"); // Provedor Microsoft usando OAuth

// Inicializa e exporta Storage
export const storage = getStorage(app);
